/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LabelsConfig,
    LabelsConfigFromJSON,
    LabelsConfigFromJSONTyped,
    LabelsConfigToJSON,
    SkipConditions,
    SkipConditionsFromJSON,
    SkipConditionsFromJSONTyped,
    SkipConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkipConfig
 */
export interface SkipConfig {
    /**
     * 
     * @type {boolean}
     * @memberof SkipConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {LabelsConfig}
     * @memberof SkipConfig
     */
    labels?: LabelsConfig;
    /**
     * 
     * @type {SkipConditions}
     * @memberof SkipConfig
     */
    conditions?: SkipConditions;
}

export function SkipConfigFromJSON(json: any): SkipConfig {
    return SkipConfigFromJSONTyped(json, false);
}

export function SkipConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkipConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'labels': !exists(json, 'labels') ? undefined : LabelsConfigFromJSON(json['labels']),
        'conditions': !exists(json, 'conditions') ? undefined : SkipConditionsFromJSON(json['conditions']),
    };
}

export function SkipConfigToJSON(value?: SkipConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'labels': LabelsConfigToJSON(value.labels),
        'conditions': SkipConditionsToJSON(value.conditions),
    };
}

